
import { i18nText } from '@/locales';


import {Component, Vue, Watch} from 'vue-property-decorator';
import PageTitle from "@/UI/components/common/PageTitle.vue";

import VisitDetailFormComponent from "@/UI/components/forms/visits/detail/VisitDetailFormComponent.vue";
import VisitCreateFormComponent from "@/UI/components/forms/visits/create/VisitCreateFormComponent.vue";

import {RouterNameEnum} from "@/router/router.types";
import {SalaryStore} from "@/store/modules/Salary";
import {StatusesStore} from "@/store/modules/Status";
import {PositionStore} from "@/store/modules/Position";
import {CategoryStore} from "@/store/modules/Category";
import {WorkersStore} from "@/store/modules/Workers";
import {IPosition} from "@/entity/position/position.types";
import {IStatus} from "@/entity/status/status.types";
import {ICategory} from "@/entity/category/category.types";
import {ISalaryScheme} from "@/entity/salaryScheme/salaryScheme.types";
import {IWorkers, IWorkersListItem} from "@/entity/workers/workers.types";
import WorkerAddForm from "@/form/workerAdd/workerAdd";
import {SalonsStore} from "@/store/modules/Salons";
import { ISalons} from "@/entity/salons/salons.types";
import VisitCreateForm from "@/form/visits/visitCreate";
import VisitGeneralForm from "@/form/visits/visitGeneral";
import { VisitsStore } from "@/store/modules/Visits";
import { IVisits, IVisitsListItem } from "@/entity/visits/visit.types";
import { checkUserRole, getUserData } from '@/router/Lib/helper';
import { ICms_Category } from '@/entity/staff/staff.types'
import { mixins } from "vue-class-component";
import { ProxyDataForm } from "@/UI/components/Helpers/ProxyDataForm";
import { ClientsStore } from "@/store/modules/Clients";
import { PaginationMix } from "@/UI/mixins/PaginationMix";
import {message} from "ant-design-vue";
import moment from 'moment';

@Component({
  components: {PageTitle, VisitCreateFormComponent, VisitDetailFormComponent},
  methods: {moment, checkUserRole}
})

export default class Visits extends mixins(
        ProxyDataForm,
        PaginationMix
    ) {

  date: string = '';
  value: '';
  type: string;
  picker: any;
 // types: string[];
  focus!: string;
  events: any[];
  colors: string[];
  names: string[];
 // categories: string[];
  categoriesCosmetologists: any[];
  categoriesCosmetologists_id: any[];
  dragTime: any | null;
  dragEvent: any | null;
  dragStart: any | null;
  createEvent: any | null;
  createStart: any | null;
  extendOriginal: null;
  start: Start | null = null
  end: End | null = null
  ready : boolean;
  typeToLabel: {};
  visible: boolean;
  select_salon_id: number;
  select_salon_name: string | undefined;

  data: any | null = null;

  title_date: string | number = 0;

  create_visit_modal_visible: boolean | false = false;;
  detail_visit_modal_visible: boolean | false = false;

  role_filtr: boolean | boolean = true;

  selectedEvent: TargetEvent  = {
      category: '',
      color: '',
      end: '',
      name: '',
      start: '',
      timed: true
  };

  cosmetolog_id: number | null = null;

  selectedElement: any = null;
  selectedOpen: boolean | false = false;
  
  targetVisit: any[] | [] = [];
  targetStart: string | '' = '';
  targetEnd: string | '' = '';

  workerForm = new WorkerAddForm();
  form  = new VisitCreateForm();
  formGeneral = new VisitGeneralForm();

    constructor() {
          super();

          this.picker = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
          
          this.value        = '';
          this.ready        = false;
          this.typeToLabel  = {
            month: 'Month',
            week: i18nText("Неделя"),
            day: 'Day',
            '4day': '4 Days',
            'category': i18nText("День")
          
          };

          this.focus                        = '';
          this.categoriesCosmetologists     = [];
          this.categoriesCosmetologists_id  = [];
          this.events                       = [];
          this.type                         = 'category';
          this.colors                       = ['#FFE46E', '#FFD5FF', '#5FFFF2', '#A9F7FF', '#69C0FF'];
          this.names                        = ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'];
          this.visible                      = false;
          this.select_salon_id              = 0;
          this.select_salon_name            = '';
          

          //this.categories = ['Косметолог 1', 'Косметолог 2', 'Косметолог 3', 'Косметолог 4'];
    }

    @Watch('select_salon_id')
    nameChanged(newVal: number) {
      this.select_salon_id = newVal;
      this.staff;
      this.getEvents();

      this.select_salon_name = SalonsStore.salons?.data.find(el => el.id == newVal)!.name;
      this.form.salon_id = this.select_salon_id;
      WorkersStore.fetchAll({limit: this.AppPageParams.pageSize, filter: {salon_id: this.select_salon_id}});
      ClientsStore.fetchAll({limit: this.AppPageParams.pageSize, filter: {salon_id: this.select_salon_id}});
    }

    // @Watch('select_salon_id', {immediate: true}) onSalonIdChanged() {
    //   console.log('TEST');
    // }

    mounted () {
      this.calendarInstance.checkChange()
    }

    create(){
        console.log(this.createEvent);
        console.log();
    }

    async saveEvent(){
      await VisitsStore.fetchAll({ 
        limit: 20, 
        filter: {
            cosmetologists_id: this.form.cosmetologists_id, 
            visit_date: this.form.visit_date +' ' + '00:00:00', 
            worker_schedule_break_time: true
          }
      })
      
        if(VisitsStore.visits !== null){
            console.log(VisitsStore.visits.data);
         
            const visit_data = VisitsStore.visits.data;
          if(visit_data !== undefined && visit_data !== null){
            for(let i = 0; i < visit_data.length; i++){

              let visit_end = visit_data[i]?.visit_date + ' ' + visit_data[i]?.visit_date_time_end;
              let visit_start = visit_data[i]?.visit_dt_start;

              if(visit_start !== null){
                if(this.form.visit_date_time_start >= visit_start && this.form.visit_date_time_end <= visit_end)
                 console.log('there');
                  message.error(i18nText("В указанное время у мастера перерыв"));
                  return;
              }

            }
          }
      }
   
      if(await this.form.submit(VisitsStore.create)){
        await VisitsStore.fetchAll({ limit: 300 });
        this.getEvents();
        this.create_visit_modal_visible = false;
      }
    }
    
    async updateEvent(){
      if(await this.formGeneral.submit(VisitsStore.update)){
            await VisitsStore.fetchAll({ limit: 500 });
            this.getEvents();
            this.detail_visit_modal_visible = false;
      }
    }
    
    showCreate(nativeEvent : any, event : any){
      try { 

        /*if(event.target.className == 'v-calendar-category__column'){
        }*/
        
        if(WorkersStore.workers !== null)
        {
          let data = WorkersStore.workers.data;
          for(let i = 0; i < data.length; i++)
          {
              if(data[i].fio == nativeEvent.category)
              {
              
                let id = data[i].id;
                this.form.cosmetologists_id = id;
              
                break;
              }
          }
        }

        this.create_visit_modal_visible = true;
        
      } catch(e) {

        console.log(e);
        this.$message.error(i18nText("Произошла ошибка"));
      }
    }

    showEvent ( { nativeEvent, event } : {nativeEvent:any, event: any}) {
      if(event.isBreackOut == false){
            console.clear();
            console.log(event);
            console.log(nativeEvent);

            this.formGeneral = new VisitGeneralForm();
            const open = () => {
                
              this.selectedEvent = event;
              this.selectedElement = nativeEvent.target;

              this.targetVisit = [];
              this.targetVisit = VisitsStore.visits!.data.filter(e => e.id == event.id);

              this.formGeneral.setFormData(this.targetVisit);

              this.formGeneral.visit_date = moment(new Date(this.selectedEvent.start).toString()).format('YYYY-MM-DD');
              let start = new Date(this.selectedEvent.start);                
              let end = new Date(this.selectedEvent.end);

              let diff = end.getTime() - start.getTime();

              this.formGeneral.visit_date_time_start  = moment(start.toString()).format('HH:mm');
              this.formGeneral.visit_date_time_end = moment(end.toString()).format('HH:mm');

              this.formGeneral.visit_duration = moment(diff.toString()).format('HH:mm');

              console.log('duration info');
              console.log(moment(new Date(this.selectedEvent.end).toString()).format('HH:mm'));
              console.log(this.formGeneral.visit_duration);

              this.detail_visit_modal_visible = true;
              this.formGeneral.visit_general_flag = true;

              requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
            }
            


            if (this.selectedOpen) {
              this.selectedOpen = false
              requestAnimationFrame(() => requestAnimationFrame(() => open()))
            } else {
              open()
            }
            nativeEvent.stopPropagation()
        }else if(event.isBreackOut == true){
              console.log("thehre");
              this.detail_visit_modal_visible = false;
              this.create_visit_modal_visible = false;
            }
        
      }
    

    hide(id:any) {
      this.visible = false;
    }
    
    hideDetail(id:any) {
          this.detail_visit_modal_visible = false;
          this.formGeneral.visit_general_flag = false;
    }

    viewDay (date:any) {
        this.focus = date;
        this.type = 'category';
    }

    setToday () {
        this.focus = '';
    }

    prev () {
      this.calendarInstance.prev()
    }

    next () {
      this.calendarInstance.next()
    }

    startDrag ({event, timed}: {event:any, timed:any}) {
      try {
        this.formGeneral = new VisitGeneralForm();
        if (event && timed) {
          this.dragEvent = event
          this.dragTime = null
          this.extendOriginal = null

          let start = moment(new Date(event.start).toString()).format('YYYY-MM-DD HH:mm');
          let end   = moment(new Date(event.end).toString()).format('YYYY-MM-DD HH:mm');


          this.targetVisit = [];
          this.targetVisit = VisitsStore.visits!.data.filter(e => e.id == event.id);

          this.formGeneral.setFormData(this.targetVisit);
        }
      } catch( e ) {
        console.log(e);
        this.$message.error(i18nText("Произошла ошибка"));
      }
       
    }

      startTime (tms:any, mouseEvent:any) {
        try {
          this.form.service_data = [];
          this.form = new VisitCreateForm();
          const mouse = this.toTime(tms);

          if(this.dragEvent && this.dragTime === null){
            const start = this.dragEvent.start;
            this.dragTime = mouse - start;
          } else {
            this.createStart = this.roundTime(mouse)

            this.createEvent = {
              start: this.createStart,
              end: this.createStart,
              name: i18nText('Новых сеансов: {count}', {count: this.events.length}),
              color: '#44944A',
              timed: true,
              category: tms.category, 
            }

       
            let time            = new Date(this.createEvent.start).toString();
            let timeDur         = new Date(this.createEvent.end).toString();
            let diffTime        = new Date(this.createEvent.end).getTime() - new Date(this.createEvent.start).getTime();

            let start_date            = moment(time).format('YYYY-MM-DD');
            let start_date_time_start = moment(time).format('HH:mm');
            let start_date_time_end   = moment(timeDur).format('HH:mm');

            let diffTimeMoment = '00:00';

            if(diffTime !== 0)
              diffTimeMoment = moment(diffTime).format('HH:mm');
     
            this.form.visit_date            = start_date;
            this.form.visit_date_time       = start_date_time_start;
            this.form.visit_date_time_start = start_date_time_start;
            this.form.visit_date_time_end   = start_date_time_end;
            this.form.visit_duration        = diffTimeMoment;
            this.form.color                 = this.createEvent.color;
            this.form.salon_id              = this.select_salon_id;

            this.events.push(this.createEvent)
          }

        } catch( e ) {
          console.log(e);
          this.$message.error(i18nText("Произошла ошибка"));
        }
    
        // this.create_visit_modal_visible = true;

      }

      extendBottom (event:any) {
        this.createEvent = event
        this.createStart = event.start
        this.extendOriginal = event.end
      }


      mouseMoveEvent(event:any){
        // console.log('mouse_move');\

        // console.log(event);
      }

      mouseMove (tms:any) {

        try {

          const mouse = this.toTime(tms)

          if(this.dragEvent && this.dragTime !== null){
            const start = this.dragEvent.start;
            const end = this.dragEvent.end;
           
            const duration = end - start;

            const newStartTime = mouse - this.dragTime;
            const newStart = this.roundTime(newStartTime);
            const newEnd = newStart + duration;

            this.dragEvent.start = newStart;
            this.dragEvent.end = newEnd;

            let start_date : string =  moment(new Date(this.dragEvent.start).toString()).format('YYYY-MM-DD');
            let start_date_time_start : string = moment(new Date(this.dragEvent.start).toString()).format('HH:mm');
            let start_date_time_end : string = moment(new Date(this.dragEvent.end).toString()).format('HH:mm');

            let duration_time : string = duration == 0 ? '00:00' :  moment(( new Date(this.dragEvent.end).getTime() - new Date(this.dragEvent.start).getTime()).toString()).format('HH:mm');

            this.formGeneral.setTimeToUpdate(start_date, start_date_time_start, start_date_time_end, duration_time);

          } else if (this.createEvent && this.createStart !== null){

            const mouseRounded = this.roundTime(mouse, false);
            const min = Math.min(mouseRounded, this.createStart);
            const max = Math.max(mouseRounded, this.createStart);

            const duration = max - min;

            this.createEvent.start = min;
            this.createEvent.end = max;

            let start_date : string      = moment(new Date(this.createEvent.start).toString()).format('YYYY-MM-DD');
            let start_date_time_start : string = moment(new Date(this.createEvent.start).toString()).format('HH:mm');
            let start_date_time_end : string = moment(new Date(this.dragEvent.end).toString()).format('HH:mm');

            let duration_time : string = duration == 0 ? '00:00' :  moment(( new Date(this.dragEvent.end).getTime() - new Date(this.dragEvent.start).getTime()).toString()).format('HH:mm');

            this.formGeneral.setTimeToUpdate(start_date, start_date_time_start, start_date_time_end, duration_time);
        
          }

        } catch( e ) {
          console.log(e);
          this.$message.error(i18nText("Произошла ошибка"));
        }
      }

      endDrag (tms:any) {
        if(this.formGeneral.visit_update_flag && this.formGeneral.id !== 0){

          this.updateEvent();
          this.formGeneral = new VisitGeneralForm();
        }
        // if(this.createEvent && this.createStart !== null){
        //   this.updateEvent();
        //   this.formGeneral = new VisitGeneralForm();
        // }
        this.dragTime = null
        this.dragEvent = null
        this.createEvent = null
        this.createStart = null
        this.extendOriginal = null
      }

      cancelDrag (tms:any) {
        if (this.createEvent) {
          if (this.extendOriginal) {
            this.createEvent.end = this.extendOriginal
          } else {
            const i = this.events.indexOf(this.createEvent)
            if (i !== -1) {
              this.events.splice(i, 1)
            }
          }
        }

        this.createEvent = null
        this.createStart = null
        this.dragTime = null
        this.dragEvent = null

        // console.log('cancel drag');


      }

      roundTime (time:any, down = true) {
        const roundTo = 15 // minutes
        const roundDownTime = roundTo * 60 * 1000

        return down
          ? time - time % roundDownTime
          : time + (roundDownTime - (time % roundDownTime))
      }

      toTime (tms:any) {
        return new Date(tms.year, tms.month - 1, tms.day, tms.hour, tms.minute).getTime()
      }

      getEventColor (event:any) {
        const rgb = parseInt(event.color.substring(1), 16)
        const r = (rgb >> 16) & 0xFF
        const g = (rgb >> 8) & 0xFF
        const b = (rgb >> 0) & 0xFF

        return event === this.dragEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event === this.createEvent
          ? `rgba(${r}, ${g}, ${b}, 0.7)`
          : event.color
      }

      
      rnd (a:any, b:any) {
        return Math.floor((b - a + 1) * Math.random()) + a;
      }
      rndElement (arr:any) {
        return arr[this.rnd(0, arr.length - 1)];
      }

      intervalFormat(interval:any) {
          return interval.time;
      }

      async getEvents(){
                              
          this.visits;
          this.events     = [];
          const eventList = [];

          if(VisitsStore.visits !== null){

              const visit_data = VisitsStore.visits.data;

              for(let j = 0; j < visit_data.length; j++){
                  if(WorkersStore.workers !== null){

                    let data = WorkersStore.workers.data;

                    for(let i = 0; i < data.length; i++){
                        if(data[i].id == visit_data[j].cosmetologists_id && visit_data[j].salon_id == this.select_salon_id){
                          console.log('FIRST GET EVENTS');
                          console.log(data[i].fio);

                            eventList.push({
                              id: visit_data[j].id,
                              start: new Date(visit_data[j].visit_dt).getTime(),
                              end:  new Date(visit_data[j].visit_dt_end).getTime(),
                              name: visit_data[j].client_id ? `${visit_data[j].client.name} ${visit_data[j].client.phone}` : i18nText("Перерыв"),
                              color: visit_data[j].color,
                              timed: true,
                              category: data[i].fio,
                              isBreackOut: visit_data[j].client_id ? false : true,
                            })                     
                        }   
                    }
                     
                  } 
              }
              this.events = eventList;

          }
      }
      
      get staffLoaded(): boolean {
        return WorkersStore.workersLoaded;
      }

      get staff(): IWorkers | null {
          // console.log("staf");
          this.categoriesCosmetologists     = [];
          this.categoriesCosmetologists_id  = [];

          if(WorkersStore.workers !== null)
          {
            let data = WorkersStore.workers.data;
            for(let i = 0; i < data.length; i++)
            {
                if(data[i].salon_id == this.select_salon_id)
                  this.categoriesCosmetologists.push(data[i].fio);
                  this.categoriesCosmetologists_id.push(data[i].id);
            }
          }
          return WorkersStore.workers;
      }


      get positions(): IPosition[] {
          return PositionStore.position;
      }
      get statuses(): IStatus[] {
          return StatusesStore.status;
      }
      /* get categories(): ICategory[] {
          return CategoryStore.category;
      } */
      get categories(): ICms_Category[] {
        return CategoryStore.category;
      } 

      get salary(): ISalaryScheme[] {
          return SalaryStore.salary;
      }

      get salons(): ISalons | null {
          return SalonsStore.salons;
      }

      get visits(): IVisits | null {
          return VisitsStore.visits;  
      }

      get visit(): IVisitsListItem | null{
        return VisitsStore.visit;
      }
  
      get title () {
        const { start, end } = this
        if (!start || !end) {
          return '';
        }
      }

      get calendarInstance (): Vue & { prev: () => void; next: () => void; checkChange: () => void; getFormatter: (format: any) => any } {
        return this.$refs.calendar as Vue & { prev: () => void; next: () => void; checkChange: () => void; getFormatter: (format: any) => any }
      }

      // cal () {
      //   return this.ready ? this.$refs.calendar : null
      // }
      // nowY () {
      //   return this.cal ? this.cal.timeToY(this.cal.times.now) + 'px' : '-10px'
      // }

      async created(): Promise<void>{
          await VisitsStore.fetchAll({ limit: 300 });
          this.visits
            await SalonsStore.fetchAll({limit: 200});

            const Role = checkUserRole();
            const UserData = getUserData();

            if(Role == 'owner')
            {
                this.select_salon_id = this.$store.state.salon_id;
                this.role_filtr = false;
            } else if(UserData && UserData.studios) {
                this.select_salon_id = UserData.studios;
            }

            await WorkersStore.fetchAll({limit: 50, filter: {salon_id: this.select_salon_id}});
            await StatusesStore.fetchAll();
            await CategoryStore.fetchAll();
            await PositionStore.fetchAll();
            await SalaryStore.fetchAll();

          this.workerForm.setFormDataWithoutId(this.positions, this.categories, this.statuses, this.salary);
          this.staff;
        

     // this.$refs.calendar!.scrollToTime('08:00')

      //console.log(this.workerForm);
    }
}

  export type TargetEvent = {
    category: string,
    color: string,
    end: string,
    name: string,
    start: string,
    timed: boolean
  }

 export type Start = {
      date: string;
      time: string;
      year: number;
      month: number;
      day: number;
      hour: number;
      minute: number;
      weekday: number;
      hasDay: boolean;
      hasTime: boolean;
      past: boolean;
      present: boolean;
      future: boolean;
    }

    export type End = {
      date: string;
      time: string;
      year: number;
      month: number;
      day: number;
      hour: number;
      minute: number;
      weekday: number;
      hasDay: boolean;
      hasTime: boolean;
      past: boolean;
      present: boolean;
      future: boolean;
    }
    export type Event = {
      name: string;
      start: string;
      end: string;
      color: string;
    }

